// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'
Vue.use(element)
import AdjustCandidates from './components/AdjustCandidates.vue';
import eventBus from "../../../../../../util/eventBus";
import {utils} from "./common/common";
(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.invoke = (eventName, args)=>{
                invoke(eventName, args)
            }
            Vue.prototype.dateFormat = utils.dateFormat;
            Vue.prototype.randomClass = 'AdjustCandidates' + Math.floor(Math.random()*10000);
            new Vue({
                el: model.dom,
                template: '<AdjustCandidates :cusParam_verifyUpdate="cusParam_verifyUpdate" :cusParam_simple="cusParam_simple" :cusParam_configData="cusParam_configData" :cusParam_rejectRsn="cusParam_rejectRsn" :cusParam_save="cusParam_save" :cusParam_saveAndSendMsg="cusParam_saveAndSendMsg" />',
                components: {
                    AdjustCandidates
                },
                data: {
                    cusParam_configData:null,
                    cusParam_rejectRsn:[],
                    cusParam_save:0,
                    cusParam_saveAndSendMsg:0,
                    cusParam_simple:false,
                    cusParam_verifyUpdate:0
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    if(props.themeNum){this.themeNum = props.themeNum;}
                    if(props.lang){this.lang = props.lang;}
                    if(props.data){
                        this.getCusParam(props,'cusParam_configData');
                        this.getCusParam(props,'cusParam_rejectRsn');
                        this.getCusParam(props,'cusParam_simple');
                    }
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        if(props.themeNum){this.themeNum = props.themeNum;}
                        if(!props.data){return}
                        this.getCusParam(props,'cusParam_configData');
                        this.getCusParam(props,'cusParam_rejectRsn');
                        this.getCusParam(props,'cusParam_save');
                        this.getCusParam(props,'cusParam_saveAndSendMsg');
                        this.getCusParam(props,'cusParam_simple');
                        this.getCusParam(props,'cusParam_verifyUpdate');
                    })
                },
                methods: {
                    getCusParam(props,key){
                        if(props.data.hasOwnProperty(key) && props.data[key]){
                            this[key] = props.data[key] ? JSON.parse(props.data[key]) : null;
                            console.log(props.data[key])
                        }
                    }
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('adjustCandidates', MyComponent,{
        isMulLang: true
    })
})(window.KDApi)
